/**
 * MIRA Button Component
 * Wraps Shadcn Button with MIRA design system styles
 */

import React from 'react';
import { Button as ShadcnButton } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/button.module.css';

export const Button = React.forwardRef(
  ({ className, variant = 'default', size = 'default', children, btnClassName, ...props }, ref) => {
    // Filter out legacy props: btnClassName is legacy, use className instead
    return (
      <ShadcnButton
        ref={ref}
        variant={variant}
        size={size}
        className={cn(styles.miraButton, btnClassName, className)}
        {...props}
      >
        {children}
      </ShadcnButton>
    );
  }
);

Button.displayName = 'MiraButton';

// Re-export buttonVariants for advanced use cases
export { buttonVariants } from '@/components/ui/button';
